<template>
  <BaseCard
    :heading="$t('account.auth.two_factor_heading')"
    mb
  >
    <template #header>
      <BaseLabel
        v-if="is2faActive"
        state="active"
        v-test="'two-factor-active-label'"
      />
    </template>
    <EmployeeList
      v-if="showEmployeeList"
      :companyUsers="employees"
      @close="showEmployeeList = false"
    />
    <BaseText mb>{{ $t('account.auth.two_factor_description') }}</BaseText>
    <Flex
      wrap
      align="center"
    >
      <BaseButton
        v-if="!is2faActive"
        :routerLink="{ name: 'enable-two-factor-auth-settings' }"
        v-test="'two-factor-enable'"
      >
        {{ $t('account.auth.two_factor_enable') }}
      </BaseButton>
      <BaseButton
        v-else
        :routerLink="{ name: 'disable-two-factor-auth-settings' }"
        color="inverted"
        v-test="'two-factor-disable'"
      >
        {{ $t('account.auth.two_factor_disable') }}
      </BaseButton>
      <BaseText
        v-if="!is2faActive"
        :href="helpPageUrl"
        target="_blank"
        v-test="'two-factor-info'"
      >
        {{ $t('account.auth.two_factor_settings.help') }}
      </BaseText>
    </Flex>
    <BaseButton
      v-if="canSeeEmployeeList"
      mt
      color="inverted"
      @click="showEmployeeList = true"
      v-test="'show-employee-list'"
    >
      {{ $t('account.auth.employee_list.header') }}
    </BaseButton>
  </BaseCard>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import { helpCenterArticleUrl } from '@/helpers/help-center';
import { useCompanyStore } from '@/stores/company';
import { useUserStore } from '@/stores/user';
import EmployeeList from './EmployeeList.vue';

export default defineComponent({
  components: {
    EmployeeList,
  },
  props: {
    is2faActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showEmployeeList: false,
      userCount: 0,
    };
  },
  computed: {
    ...mapState(useUserStore, ['user']),
    ...mapState(useCompanyStore, ['company']),
    canSeeEmployeeList() {
      return this.is2faActive && this.user.admin && this.userCount > 0;
    },
    helpPageUrl() {
      return helpCenterArticleUrl(6115892);
    },
  },
  apollo: {
    employees: {
      query: gql`
        query getCompanyUsers {
          companyUsers {
            id
            firstName
            twoFactorSettings {
              status
              mode
            }
          }
        }
      `,
      result() {
        this.userCount = this.employees.length;
      },
      update(data) {
        return data.companyUsers;
      },
    },
  },
});
</script>
